import { BlockType } from '../../types/index.js';
import { FormBlock as Component } from './Block.js';
export const RegisteredFormBlock = (_intl) => ({
    recommendedName: 'Form',
    Component,
    config: {
        type: BlockType.BuildingBlock,
    },
});
//# sourceMappingURL=registered.js.map